import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import BlogManager from "./BlogManager";
import "./Admin.css";

const AdminDashboard = () => {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState("blogs");

  // Check if admin is logged in
  useEffect(() => {
    const isLoggedIn = localStorage.getItem("adminLoggedIn");
    if (!isLoggedIn) {
      navigate("/admin/login");
    }
  }, [navigate]);

  const handleLogout = () => {
    localStorage.removeItem("adminLoggedIn");
    localStorage.removeItem("adminUsername");
    navigate("/admin/login");
  };

  return (
    <div className="admin-dashboard">
      <nav className="admin-nav">
        <div className="admin-nav-left">
          <h2>Admin Dashboard</h2>
          <span className="admin-user">👤 {localStorage.getItem("adminUsername")}</span>
        </div>
        <div className="admin-nav-right">
          <button 
            className={`nav-tab ${activeTab === 'blogs' ? 'active' : ''}`}
            onClick={() => setActiveTab('blogs')}
          >
            📝 Blog Manager
          </button>
          <button onClick={handleLogout} className="logout-btn">
            Logout
          </button>
        </div>
      </nav>

      <div className="admin-content">
        {activeTab === 'blogs' && <BlogManager />}
      </div>
    </div>
  );
};

export default AdminDashboard;